export const API_ROUTES = {
  // Auth
  LOGIN: '/Auth/login',
  REGISTER: '/Auth/register',
  VERIFY_EMAIL: '/Auth/verify-email',
  RESEND_VERIFICATION: '/Auth/resend-verification',
  SOCIAL_LOGIN: '/Auth/socialmedia-login',
  FORGOT_PASSWORD: '/Auth/forgot-password',
  RESET_PASSWORD: '/Auth/reset-password',
  SET_PASSWORD: '/Auth/set-password',
  ACCEPT_INVITATION: '/Auth/accept-invitation',
  ACCEPT_EXISTING_USER_INVITATION: '/User/accept-existinguserinvitation',
  VERIFY_TOKEN: '/Auth/verify-token',

  // User onboarding
  CREATE_FAMILY_SPACE_AND_MEMBER: '/User/CreateFamilySpaceAndmember',
  VALIDATE_FAMILY_MEMBER_EMAIL: '/User/validate-familymember',
  SKIP_FAMILY_SPACE: '/User/skip-add-family-space',

  // Profile
  GET_PROFILE: '/Client/GetProfileById',
  UPDATE_PROFILE: '/Client/UpdateProfile',
  UPDATE_PASSWORD: '/Client/ChangePassword',
  UPDATE_PROFILE_PICTURE: '/Client/UpdateProfileImage',

  // Dashboard
  GET_DASHBOARD_STATS: '/Client/GetDashboardStats',
  GET_RECENT_ACTIVITY: '/Client/GetRecentActivity',

  // Stories — listing
  GET_STORY_LISTING: '/Story/GetStoryListing',
  GET_STORY_MASTER_DATA: '/Story/GetStoryMasterData',
  GET_ACTIVE_CATEGORIES: '/Story/GetActiveCategories',
  GET_PROMPTS_FOR_CATEGORY: '/Story/GetPromptsForCategory',
  GET_ACTIVE_FAMILY_LIST: '/Story/GetActiveFamilyList',
  GET_FAMILY_MEMBER_LIST: '/Story/GetFamilyMemberList',
  GET_ALL_CREATOR_LIST: '/Story/GetAllCreatorList',

  // Stories — detail & reactions
  /** GET /Story/GetStoryDetail/{storyId} */
  GET_STORY_DETAIL: '/Story/GetStoryDetail',
  /** POST /Story/AddReaction — body: AddReactionRequest */
  ADD_REACTION: '/Story/AddReaction',
  /** DELETE /Story/RemoveReaction/{storyId} */

  // User Settings
  /** GET  /UserSettings/GetProfileSettings */
  SETTINGS_GET_PROFILE: '/UserSettings/GetProfileSettings',
  /** PUT  /UserSettings/UpdateProfileSettings */
  SETTINGS_UPDATE_PROFILE: '/UserSettings/UpdateProfileSettings',
  /** GET  /UserSettings/GetPrivacySettings */
  SETTINGS_GET_PRIVACY: '/UserSettings/GetPrivacySettings',
  /** PUT  /UserSettings/UpdateDefaultStoryPrivacy */
  SETTINGS_UPDATE_DEFAULT_STORY_PRIVACY: '/UserSettings/UpdateDefaultStoryPrivacy',
  /** PUT  /UserSettings/UpdateProfileVisibility */
  SETTINGS_UPDATE_PROFILE_VISIBILITY: '/UserSettings/UpdateProfileVisibility',
  /** PUT  /UserSettings/ChangePassword */
  SETTINGS_CHANGE_PASSWORD: '/UserSettings/ChangePassword',
  /** PUT  /UserSettings/UpdateProfileImage */
  SETTINGS_UPDATE_PROFILE_IMAGE: '/UserSettings/UpdateProfileImage',
  /** GET  /UserSettings/GetNotificationSettings */
  SETTINGS_GET_NOTIFICATIONS: '/UserSettings/GetNotificationSettings',
  /** PUT  /UserSettings/UpdateNotificationSettings */
  SETTINGS_UPDATE_NOTIFICATIONS: '/UserSettings/UpdateNotificationSettings',
  /** GET  /UserSettings/PreCheckAccountDeletion */
  SETTINGS_PRE_CHECK_DELETION: '/UserSettings/PreCheckAccountDeletion',
  /** DELETE /UserSettings/DeleteAccount */
  SETTINGS_DELETE_ACCOUNT: '/UserSettings/DeleteAccount',

  // Common
  /** POST /Common/GetAllMasterList — body: { typeIds: number[] } */
  COMMON_GET_ALL_MASTER_LIST: '/Common/GetAllMasterList',
  REMOVE_REACTION: '/Story/RemoveReaction',
  /** PUT /Story/UpdateStoryTranscript — body: UpdateTranscriptRequest */
  UPDATE_STORY_TRANSCRIPT: '/Story/UpdateStoryTranscript',
  /** GET /Story/DownloadVideoFromVimeo/{videoId} */
  DOWNLOAD_VIDEO_FROM_VIMEO: '/Story/DownloadVideoFromVimeo',
  /** POST /Story/ShareStoryWithMembers — body: ShareStoryWithMembersRequest */
  SHARE_STORY_WITH_MEMBERS: '/Story/ShareStoryWithMembers',
  /** POST /Story/TagStoryWithMembers — body: TagStoryWithMembersRequest */
  TAG_STORY_WITH_MEMBERS: '/Story/TagStoryWithMembers',
  /** POST /Story/ReportStory — body: ReportStoryRequest */
  REPORT_STORY: '/Story/ReportStory',
  CREATE_AND_PUBLISH_STORY: '/Story/createandpublishstory',
  GET_EMOTIONAL_TONES: '/Story/GetEmotionalTones',

  // Loved Ones
  /** GET /LovedOnes/LovedOnesPageData */
  GET_LOVED_ONES_PAGE_DATA: '/LovedOnes/LovedOnesPageData',
  /** POST /LovedOnes/GetFamilyMembersByFamilySpaceId */
  GET_FAMILY_MEMBERS_BY_SPACE: '/LovedOnes/GetFamilyMembersByFamilySpaceId',
  /** POST /LovedOnes/AddFamilyMember */
  ADD_FAMILY_MEMBER: '/LovedOnes/AddFamilyMember',
  /** POST /LovedOnes/EditFamilyMember */
  UPDATE_FAMILY_MEMBER: '/LovedOnes/EditFamilyMember',
  /** POST /LovedOnes/RemoveFamilyMember */
  REMOVE_FAMILY_MEMBER: '/LovedOnes/RemoveFamilyMember',
  /** POST /LovedOnes/CreateFamilyGroup */
  CREATE_FAMILY_GROUP: '/LovedOnes/CreateFamilyGroup',
  /** POST /LovedOnes/EditFamilyGroup */
  UPDATE_FAMILY_GROUP: '/LovedOnes/EditFamilyGroup',
  /** GET /LovedOnes/GetFamilySpaceDetailById/{familySpaceId} */
  GET_FAMILY_SPACE_DETAIL_BY_ID: '/LovedOnes/GetFamilySpaceDetailById',
  /** GET /LovedOnes/GetFamilyMemberDetailById/{familyMemberId} */
  GET_FAMILY_MEMBER_DETAIL_BY_ID: '/LovedOnes/GetFamilyMemberDetailById',

  // Custom Questions
  ADD_CUSTOM_QUESTION: '/SchedulePrompt/AddCustomQuestion',
  UPDATE_CUSTOM_QUESTION: '/SchedulePrompt/UpdateCustomQuestion',
  DELETE_CUSTOM_QUESTION: '/SchedulePrompt/DeleteCustomQuestion',

  // Schedule Prompt
  SP_GET_PROMPT_LIST: '/SchedulePrompt/GetSchedulePromptList',
  SP_GET_CATEGORIES: '/SchedulePrompt/GetCategories',
  SP_GET_QUESTIONS_BY_CATEGORY: '/SchedulePrompt/GetQuestionsByCategory',
  SP_CREATE_AND_PUBLISH: '/SchedulePrompt/CreateAndPublishSchedulePrompt',
  SP_DELETE_PROMPT: '/SchedulePrompt/DeleteSchedulePrompt',
  SP_GET_CREATOR_DETAIL: '/SchedulePrompt/GetPromptDetailForCreator',
  SP_GET_INVITEE_DETAIL: '/SchedulePrompt/GetPromptDetailForInvitee',
  SP_STOP_PROMPT: '/SchedulePrompt/StopSchedulePrompt',
  SP_UPDATE_PROMPT: '/SchedulePrompt/UpdateSchedulePrompt',
  SP_GET_FAMILY_MEMBERS: '/Story/GetFamilyMemberList',
  SP_GET_DETAIL_PROMPT_OVERVIEW: '/SchedulePrompt/GetSchedulePromptOverview',

  // Schedule Prompt — Email Recording Link
  /** GET /SchedulePrompt/ValidateRecordingLink/{deliveryId} */
  VALIDATE_RECORDING_LINK: '/SchedulePrompt/ValidateRecordingLink',
  /**
   * POST /SchedulePrompt/SubmitPromptResponse
   * Payload: SubmitPromptResponseRequestModel
   *   schedulePromptId, questions: [{questionId, startTime, endTime}],
   *   mediaUrl, mediaType, trimStart, trimEnd, duration,
   *   audioImageFileName, thumbnailFileName
   */
  SUBMIT_SCHEDULED_PROMPT_RECORDING: '/SchedulePrompt/SubmitPromptResponse',

  //story-book
  STORY_BOOK_GET_LIST: '/Storybooks',
  STORY_BOOK_CREATE: '/Storybooks',
  /** DELETE /Storybooks/DeleteStorybook/{storybookId} */
  STORY_BOOK_DELETE: '/Storybooks/DeleteStorybook',
  STORY_BOOK_GET_STORIES: '/Storybooks/GetStories',
  /** GET /Storybooks/GetStorybookDetail/{storybookId} */
  STORY_BOOK_GET_DETAIL: '/Storybooks/GetStorybookDetail',
  /** POST /Storybooks/ExportStorybook — body: ExportStorybookRequest */
  STORY_BOOK_EXPORT: '/Storybooks/ExportStorybook',
  /** POST /Storybooks/GenerateShareableQRCode/{storybookId} */
  STORY_BOOK_GENERATE_QR_CODE: '/Storybooks/GenerateShareableQRCode',
  /** GET /Storybooks/PreviewStorybook/{storybookId} */
  STORY_BOOK_PREVIEW: '/Storybooks/PreviewStorybook',
  /** POST /Storybooks/UpdateStorybook — body: UpdateStorybookRequest */
  STORY_BOOK_UPDATE: '/Storybooks/UpdateStorybook',
} as const;
